import styles from './style.module.scss';
import { Spin, Descriptions, Col, Row } from 'antd';
import { Button, PageHeader } from 'components';
import { useTranslation } from 'react-i18next';

import useCandidatesAuto from '../useCandidatesAuto';
import { FilePdfOutlined, PlusOutlined } from '@ant-design/icons';

const Single = () => {
  const { t } = useTranslation();
  const { singleItem, handleDownloadPdf, updateInProcess, handleAddWishList } =
    useCandidatesAuto(false);

  const title = t('CANDIDATURE SPONTANEE');

  const data = singleItem?.allData;

  return (
    <div>
      <PageHeader title={title}>
        <Row gutter={16}>
          <Col>
            <Button
              type={'green'}
              big
              upperCase
              loading={updateInProcess}
              onClick={() =>
                handleDownloadPdf(data?.cv?.file_name, data?.cv?.file_url)
              }
              icon={<FilePdfOutlined />}
              disabled={!data?.cv?.file_name}
            >
              {t('Scarica cv')}
            </Button>
          </Col>
          <Col>
            <Button
              type={'green'}
              big
              upperCase
              loading={updateInProcess}
              onClick={() =>
                handleDownloadPdf(data?.file?.file_name, data?.file?.file_url)
              }
              icon={<FilePdfOutlined />}
              disabled={!data?.file?.file_name}
            >
              {t('Scarica allegato')}
            </Button>
          </Col>
          <Col>
            <Button
              loading={updateInProcess}
              onClick={() => handleAddWishList(singleItem)}
              big
              upperCase
              icon={<PlusOutlined />}
              disabled={data?.is_wishlist}
            >
              {t('Aggiungi alla wishlist')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.content}>
        <Descriptions column={1} bordered>
          {data ? (
            <>
              <Descriptions.Item label={t('Outlet Village')}>
                {data?.shopping_center}
              </Descriptions.Item>
              <Descriptions.Item label={t('ID Candidato')}>
                {data?.candidature_id}
              </Descriptions.Item>
              <Descriptions.Item label={t('Cognome')}>
                {data?.surname}
              </Descriptions.Item>
              <Descriptions.Item label={t('Nome')}>
                {data?.name}
              </Descriptions.Item>
              <Descriptions.Item label={t('Settore')}>
                {data?.vacancy_application_type?.title}
              </Descriptions.Item>
              <Descriptions.Item label={t('Profilo candidato')}>
                {data?.vacancy_category?.title}
              </Descriptions.Item>
              <Descriptions.Item label={t('Sesso')}>
                {data?.sex_short}
              </Descriptions.Item>
              <Descriptions.Item label={t('Fascia d’età')}>
                {data?.birthday_range_title}
              </Descriptions.Item>
              <Descriptions.Item label={t('Anni esp')}>
                {data?.experience_year?.title}
              </Descriptions.Item>
              <Descriptions.Item label={t('Disponibilita` contratto')}>
                {data?.contract_type?.title}
              </Descriptions.Item>
              <Descriptions.Item label={t('Provincia')}>
                {data?.region?.title}
              </Descriptions.Item>
              <Descriptions.Item label={t('Lingua 1')}>
                {data?.vacancy_language?.title}
              </Descriptions.Item>
              <Descriptions.Item label={t('Livello lingua 1')}>
                {data?.vacancy_language_level}
              </Descriptions.Item>
              <Descriptions.Item label={t('Lingua 2')}>
                {data?.vacancy_language2?.title}
              </Descriptions.Item>
              <Descriptions.Item label={t('Livello lingua 2')}>
                {data?.vacancy_language2_level}
              </Descriptions.Item>
              <Descriptions.Item label={t('Whishlist')}>
                {data?.is_wishlist ? 'Si' : 'No'}
              </Descriptions.Item>
              <Descriptions.Item label={t('Note')}>
                {data?.comment}
              </Descriptions.Item>
            </>
          ) : (
            <Spin size={'large'} />
          )}
        </Descriptions>
      </div>
    </div>
  );
};

export default Single;
